import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IContratoCliente } from '@model/ContratoCliente';
import ILinha from '@model/Linha';
import { useRelatorioService } from '@services/RelatorioService';
import React from 'react';
import { ConferenciaChipDetalhesTable } from './ConferenciaChipDetalhesTable';

export type ConferenciaChipDetalhesModalProps = {
    linha: ILinha
    modal: IModalWindow
}

export function ConferenciaChipDetalhesModal ({ linha, modal }: ConferenciaChipDetalhesModalProps) {
    const formatter = useFormatter();
    const loading = useLoading();
    const message = useMessage();

    const data = useData<IContratoCliente>();

    const relatorioService = useRelatorioService();
    
    const handleEnter = React.useCallback(() => {
        data.clear();

        if (!loading.isLoading) {
            loading.start();
            relatorioService.listarConferenciaChipContratos(linha.linhaId)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [data, linha.linhaId, loading, message.showException, relatorioService]);

    return (
        <ModalWindow
            modal={modal}
            size="md"
            disabled={loading.isLoading}
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Histórico de Contratos da Linha ${formatter.toCelular(linha.numeroSemMascara)} (${linha.linhaId})`}
            />
            
            <ModalWindowContent>
                <ConferenciaChipDetalhesTable 
                    data={data}
                />
            </ModalWindowContent>
        </ModalWindow>
    )
}